import React from 'react';

const IndividualCOachingCompo = () => {
    return (
        <div className='mx-auto mb-10'>
            <h1 className='text-md my-5'>This is a one-on-one nutrition coaching to address individual
                goals and limitations. Physical training without proper nutrition
                doesn't work. This program is for everyone. If there is a question
                about which one comes first, Nutrition coaching should be
                advised before training. </h1>

        </div>
    );
};

export default IndividualCOachingCompo;